const rules = [
    {
        check: function (item) {
            let vitamins = item.nutrients.filter((nutrient) => {
                if (nutrient.group == 'Витамины' && nutrient.type == 'element') {
                    let val = nutrient.rate_100_g.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)

                    if (!val) {
                        return false
                    }

                    return val >= 8
                } else {
                    return false
                }
            })

            if (!vitamins.length) {
                let allVitamins = item.nutrients.filter((nutrient) => {
                    if (nutrient.group == 'Витамины' && nutrient.type == 'element' && nutrient.rate_100_g != '') {
                        return true
                    } else {
                        return false
                    }
                })

                allVitamins.sort((a,b) => b.rate_100_g.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/) - a.rate_100_g.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/));

                if (allVitamins[0]) {
                    vitamins.push(allVitamins[0])
                }

                if (allVitamins[1]) {
                    vitamins.push(allVitamins[1])
                }

                if (allVitamins[2]) {
                    vitamins.push(allVitamins[2])
                }
            }

            if (!vitamins.length) {
                return ;
            }

            let resultString = ''

            if (vitamins.length === 1) {
                resultString = vitamins[0].name + ' - ' + vitamins[0].rate_100_g
            }

            if (vitamins.length === 2) {
                resultString = vitamins[0].name + ' - ' + vitamins[0].rate_100_g + ' и ' +  vitamins[1].name + ' - ' + vitamins[1].rate_100_g
            }

            if (vitamins.length > 2) {
                vitamins.forEach((vitamin, i) => {
                    if (i < vitamins.length - 2) {
                        resultString = resultString + vitamin.name + ' - ' + vitamin.rate_100_g + ', '
                    }
                    if (i == vitamins.length - 2) {
                        resultString = resultString + vitamin.name + ' - ' + vitamin.rate_100_g + ' и '
                    }
                    if (i == vitamins.length - 1) {
                        resultString = resultString + vitamin.name + ' - ' + vitamin.rate_100_g
                    }
                })
            }

            return `Продукт ${item.name} богат больше всего такими витаминами, как: ${resultString}`
        },
        include_cat: [],
        exclude_cat: [
        ]
    },
    {
        check: function (item) {
            let elements = item.nutrients.filter((nutrient) => {
                if ((nutrient.group == 'Макроэлементы' || nutrient.group == 'Микроэлементы')  && nutrient.type == 'element') {
                    if (nutrient.name == 'Натрий, Na' || nutrient.name == 'Сера, S') {
                        return false
                    }

                    let val = nutrient.rate_100_g.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)

                    if (!val) {
                        return false
                    }

                    if (nutrient.group == 'Макроэлементы') {
                        return val >= 11
                    }

                    if (nutrient.group == 'Микроэлементы') {
                        return val >= 7
                    }
                } else {
                    return false
                }
            })

            if (!elements.length) {
                let allNutrients = item.nutrients.filter((nutrient) => {
                    if ((nutrient.group == 'Макроэлементы' || nutrient.group == 'Микроэлементы')  && nutrient.type == 'element') {
                        if (nutrient.name == 'Натрий, Na' || nutrient.name == 'Сера, S') {
                            return false
                        }

                        return true
                    } else {
                        return false
                    }
                })

                allNutrients.sort((a,b) => b.rate_100_g.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/) - a.rate_100_g.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/));

                if (allNutrients[0]) {
                    elements.push(allNutrients[0])
                }

                if (allNutrients[1]) {
                    elements.push(allNutrients[1])
                }

                if (allNutrients[2]) {
                    elements.push(allNutrients[2])
                }
            }

            if (!elements.length) {
                return ;
            }

            let resultString = ''

            if (elements.length === 1) {
                resultString = elements[0].name + ' - ' + elements[0].rate_100_g
            }

            if (elements.length === 2) {
                resultString = elements[0].name + ' - ' + elements[0].rate_100_g + ' и ' +  elements[1].name + ' - ' + elements[1].rate_100_g
            }

            if (elements.length > 2) {
                elements.forEach((element, i) => {
                    if (i < elements.length - 2) {
                        resultString = resultString + element.name + ' - ' + element.rate_100_g + ', '
                    }
                    if (i == elements.length - 2) {
                        resultString = resultString + element.name + ' - ' + element.rate_100_g + ' и '
                    }
                    if (i == elements.length - 1) {
                        resultString = resultString + element.name + ' - ' + element.rate_100_g
                    }
                })
            }

            return `Из минеральных веществ, которые максимально содержатся в продукте ${item.name} можно выделить: ${resultString}`
        },
        include_cat: [],
        exclude_cat: [
        ]
    },
    {
        check: function (item) {
            let calories100 = getItemNutrient(item.nutrients, 'Калорийность');

            let elements = item.nutrients.filter((nutrient) => {
                let am = [
                    'валин', 'изолейцин', 'лейцин', 'лизин', 'метионин', 'треонин', 'триптофан', 'фенилаланин'
                ]
                if (am.includes(nutrient.name.toLowerCase())) {
                    let val = nutrient.value.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)

                    return (val / calories100) * 100 > 0.1
                } else {
                    return false
                }
            })

            if (!elements.length) {
                return ;
            }

            let resultString = ''

            if (elements.length === 1) {
                resultString = elements[0].name
            }

            if (elements.length === 2) {
                resultString = elements[0].name + ' и ' +  elements[1].name
            }

            if (elements.length > 2) {
                elements.forEach((element, i) => {
                    if (i < elements.length - 2) {
                        resultString = resultString + element.name + ', '
                    }
                    if (i == elements.length - 2) {
                        resultString = resultString + element.name + ' и '
                    }
                    if (i == elements.length - 1) {
                        resultString = resultString + element.name
                    }
                })
            }

            return `В продукте ${item.name} содержатся незаменимые аминокислоты, такие как: ${resultString}`
        },
        include_cat: [],
        exclude_cat: [
        ]
    },
    {
        check: function (item) {
            let calories100 = getItemNutrient(item.nutrients, 'Калорийность');

            let elements = item.nutrients.filter((nutrient) => {
                let am = [
                    '18:2 линолевая', '18:3 линоленовая', '18:1 олеиновая (омега-9)', '16:1 пальмитолеиновая', '17:1 гептадеценовая', '20:1 гадолеиновая (омега-9)', '20:3 эйкозатриеновая'
                ]

                if (am.includes(nutrient.name.toLowerCase())) {
                    let val = nutrient.value.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)

                    return (val / calories100) * 100 > 0.1
                } else {
                    return false
                }
            })

            if (!elements.length) {
                return ;
            }

            let resultString = ''

            if (elements.length === 1) {
                resultString = elements[0].name
            }

            if (elements.length === 2) {
                resultString = elements[0].name + ' и ' +  elements[1].name
            }

            if (elements.length > 2) {
                elements.forEach((element, i) => {
                    if (i < elements.length - 2) {
                        resultString = resultString + element.name + ', '
                    }
                    if (i == elements.length - 2) {
                        resultString = resultString + element.name + ' и '
                    }
                    if (i == elements.length - 1) {
                        resultString = resultString + element.name
                    }
                })
            }

            return `Из жирных кислот максимальную пользу здоровью при употреблении продукта ${item.name} принесут ${resultString}`
        },
        include_cat: [],
        exclude_cat: [
        ]
    },
    {
        check: function (item) {
            let elements = [];

            let proteins = getItemNutrient(item.nutrients, 'Белки')
            let calories100 = getItemNutrient(item.nutrients, 'Калорийность');
            let polFats = getItemNutrient(item.nutrients, 'Полиненасыщенные жирные кислоты');
            let CARate = getItemNutrientRate(item.nutrients, 'Кальций, Ca');
            let MgRate = getItemNutrientRate(item.nutrients, 'Магний, Mg');
            let ZnRate = getItemNutrientRate(item.nutrients, 'Цинк, Zn');
            let volokna = getItemNutrientRate(item.nutrients, 'Пищевые волокна');
            let Fe = getItemNutrientRate(item.nutrients, 'Железо, Fe');

            let fatPercent = ((proteins * 4) / calories100) * 100
            if (fatPercent > 15) {
                elements.push({name: 'содержит много белка'})
            }

            if (calories100 < 50) {
                elements.push({name: 'обладает низкой калорийностью'})
            }

            if (['Жиры и масла', 'Орехи и семена'].includes(item.category_name) && polFats > 12) {
                elements.push({name: 'имеет высокое содержание полиненасыщенных жирных кислот'})
            }

            if (CARate > 11) {
                elements.push({name: 'полезен для крепких костей'})
            }

            if (MgRate > 10) {
                elements.push({name: 'благотворно влияет на сердечный ритм'})
            }

            if (ZnRate > 12) {
                elements.push({name: 'помогает сохранить красоту'})
            }

            if (volokna > 10) {
                elements.push({name: 'содержит много клетчатки'})
            }

            if (Fe > 16) {
                elements.push({name: 'помогает быть энергичнее'})
            }

            if (!elements.length) {
                return ;
            }

            let resultString = ''

            if (elements.length === 1) {
                resultString = elements[0].name
            }

            if (elements.length === 2) {
                resultString = elements[0].name + ' и ' +  elements[1].name
            }

            if (elements.length > 2) {
                elements.forEach((element, i) => {
                    if (i < elements.length - 2) {
                        resultString = resultString + element.name + ', '
                    }
                    if (i == elements.length - 2) {
                        resultString = resultString + element.name + ' и '
                    }
                    if (i == elements.length - 1) {
                        resultString = resultString + element.name
                    }
                })
            }

            return `Также продукт ${item.name} ${resultString}`
        },
        include_cat: [],
        exclude_cat: [
        ]
    }
]

export const getPros = (item) => {
    let pros = [];

    rules.forEach((rule, i) => {
        if (rule.exclude_cat.length && rule.exclude_cat.includes(item.category_name)) {
            return;
        }

        if (rule.include_cat.length && !rule.include_cat.includes(item.category_name)) {
            return;
        }

        let result = rule.check(item);

        if (result) {
            pros.push(result)
        }

    })

    return pros;
}

function getItemNutrient(nutrients, name) {
    let nutrient = nutrients.find(e => e.name == name && e.value != '')
    if (!nutrient) {
        return 0;
    }
    let val = nutrient.value.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)

    if (val) {
        return val[0]
    }

    return 0
}

function getItemNutrientRate(nutrients, name) {
    let nutrient = nutrients.find(e => e.name == name && e.value != '')
    if (!nutrient) {
        return 0;
    }

    let val = nutrient.rate_100_g.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)

    if (val) {
        return val[0]
    }

    return 0
}